export enum ClientType {
  Driver = 'driver',
  Rider = 'rider',
}
export interface ISupportedClientsGetResponse {
  minVersion: string
}
